import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import GUI from "lil-gui";
const dracoLoader = new DRACOLoader();

dracoLoader.setDecoderPath("draco/");
//Loaders
const gltfLoader = new GLTFLoader();
gltfLoader.setDRACOLoader(dracoLoader);

const gui = new GUI();
/**
 * Bases
 */
// Debug

// Canvas
const canvas = document.querySelector("canvas.webgl");

// Scene
const scene = new THREE.Scene();

/**
 * Test sphere
 */

//Textures
const updateAllMaterials = () => {
  scene.traverse((child) => {
    if (
      child instanceof THREE.Mesh &&
      child.material instanceof THREE.MeshStandardMaterial
    ) {
      child.castShadow = true;
      child.receiveShadow = true;
    }
  });
};
//Models
gltfLoader.load("models/House5.glb", (gltf) => {
  scene.add(gltf.scene);
  updateAllMaterials();
  const tick2 = () => {
    gltf.scene.rotation.y += -0.001;
    window.requestAnimationFrame(tick2);
  };
  tick2();
});

const layeringMap = new THREE.TextureLoader().load(
  "textures/background-sky-cartoon-style.png"
);

scene.background = layeringMap;
//lights
const light = new THREE.HemisphereLight("#a9ffab", "#6D3CFF", 3.903);
const ambientLight = new THREE.AmbientLight("#DB7D2B", 2.87);

const directionalLight = new THREE.DirectionalLight("white", 2.379);
directionalLight.castShadow = true;
directionalLight.position.set(3, 2, 0);
directionalLight.shadow.normalBias = 0.05;

//camera angle
directionalLight.shadow.camera.far = 8;
directionalLight.shadow.camera.top = 1;
directionalLight.shadow.camera.bottom = -2;
directionalLight.shadow.camera.left = -4;
directionalLight.shadow.camera.right = 4;
// directionalLight.shadow.camera.radius = 10;

directionalLight.shadow.mapSize.set(1024, 1024);

//directional Light 2
const directionalLight2 = new THREE.DirectionalLight("#FFA67E", 4.222);
directionalLight2.castShadow = true;
directionalLight2.position.set(3, 2, 0);
directionalLight2.shadow.normalBias = 0.05;

//camera angle
directionalLight2.shadow.camera.far = 8;
directionalLight2.shadow.camera.top = 1;
directionalLight2.shadow.camera.bottom = -2;
directionalLight2.shadow.camera.left = -4;
directionalLight2.shadow.camera.right = 4;
// directionalLight2.shadow.camera.radius = 10;

directionalLight2.shadow.mapSize.set(512, 512);

//end

//directional Light 3

const directionalLight3 = new THREE.DirectionalLight("#ED94FF", 3.608);
directionalLight3.castShadow = true;
directionalLight3.position.set(3, 2, 0);
directionalLight3.shadow.normalBias = 0.05;

//camera angle
directionalLight3.shadow.camera.far = 8;
directionalLight3.shadow.camera.top = 1;
directionalLight3.shadow.camera.bottom = -2;
directionalLight3.shadow.camera.left = -4;
directionalLight3.shadow.camera.right = 4;
// directionalLight3.shadow.camera.radius = 10;

directionalLight3.shadow.mapSize.set(256, 256);

// const directionalLightShadow = new THREE.DirectionalLightHelper(
//   directionalLight
// );
// const directionalLightCameraHelper = new THREE.CameraHelper(
//   directionalLight.shadow.camera
// );
// scene.add(directionalLightCameraHelper);
// scene.add(directionalLightShadow);
scene.add(light);
scene.add(ambientLight);
scene.add(directionalLight);
scene.add(directionalLight2);
scene.add(directionalLight3);
gui.add(light, "intensity", 0, 50, 0.001);
gui.add(ambientLight, "intensity", 0, 10, 0.001);
gui.add(directionalLight, "intensity", 0, 10, 0.001).name("1");
gui.add(directionalLight2, "intensity", 0, 10, 0.001).name("2");
gui.add(directionalLight3, "intensity", 0, 10, 0.001).name("3");
/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
  75,
  sizes.width / sizes.height,
  0.1,
  100
);
camera.position.set(1.4895767636687998, 1.1889790819077577, 7.788295779654473);
scene.add(camera);

// Controls
const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
  antialias: true,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.physicallyCorrectLights = true;
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;

/**
 * Animate
 */
const tick = () => {
  // Update controls
  controls.update();

  // Render
  renderer.render(scene, camera);

  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
};

tick();
